import { api } from './api'
import { openExternalBrowser } from './externalBrowser'

type PublicDashboardKind = 'events' | 'commitments' | 'rolodex'

const DEFAULT_PUBLIC_DASHBOARDS_URL = 'https://agentchat-dashboards.onrender.com'
const CONFIGURED_PUBLIC_DASHBOARDS_URL =
  ((import.meta.env.VITE_PUBLIC_DASHBOARDS_URL as string | undefined) ?? DEFAULT_PUBLIC_DASHBOARDS_URL)
    .trim()
    .replace(/\/+$/, '')

function fallbackUrl(kind: PublicDashboardKind): string {
  return `${CONFIGURED_PUBLIC_DASHBOARDS_URL}/${kind}`
}

export async function openPublicDashboard(kind: PublicDashboardKind): Promise<void> {
  try {
    const { url } = await api<{ url: string }>(`/api/public-dashboards/share-url/${kind}`)
    await openExternalBrowser(url)
  } catch {
    await openExternalBrowser(fallbackUrl(kind))
  }
}
